module.exports = __webpack_public_path__ + "img/horizontal_3_4_5012.26c922d8.png";